import React from 'react';
// import {Footer} from './features/Footer/Footer';
import {AppRoutes} from './routes';
import './App.css';
import '@progress/kendo-theme-default/dist/all.css';

function App() {
  return (
    <div className="App">
        <AppRoutes/>
        {/* <Footer /> */}
    </div>
  );
}

export default App;
